module.exports = __webpack_public_path__ + "media/images/lit bébé-fea7bc330c9485ab243d145dfd015c1a.svg";